
import React from 'react';
import PropTypes from 'prop-types';

import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';

import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import LoaderOverlay from '../LoaderOverlay';
import { confirmDialog } from '../../util/dialogs';

// TODO: if you click `start over` from here, the process will keep going in the background
const repeatIcon = <FontIcon className="material-icons">repeat</FontIcon>;

const styles = {
  contentStyle: {
    margin: '20px 0',
  },
  flexBox: {
    marginTop: 20,
    display: 'flex',
  },
  buttonArea: {
    paddingTop: 0,
  },
  buttonSpacer: {
    paddingLeft: 20,
  },
  horizontalFiller: {
    marginLeft: 'auto',
  },
}


/**
 * Horizontal steppers are ideal when the contents of one step depend on an earlier step.
 * Avoid using long step names in horizontal steppers.
 *
 * Linear steppers require users to complete one step in order to move on to the next.
 */
class StepperManager extends React.Component {

  static propTypes = {
    initialStepIndex: PropTypes.number,  // optionally start processing from a certain point
    sessionHash: PropTypes.string, // optionally set the sessionHash externally, to continue working from a certain point
    stepperContentProvider: PropTypes.any.isRequired,
    stepDescriptions: PropTypes.array.isRequired,
    onStartOverClicked: PropTypes.func.isRequired,
    onStepIndexChange: PropTypes.func,
  }

  state = {
    stepIndex: this.props.initialStepIndex || 0,
    allowNext: false,
    loading: false,
    hash: this.props.sessionHash || '',
  };

  componentWillMount() {
    this.props.onStepIndexChange(this.state.stepIndex);
  }

  handleNext = () => {
    const { stepIndex } = this.state;
    this.setState({
      stepIndex: stepIndex + 1,
    });
    this.props.onStepIndexChange(stepIndex + 1);
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
      this.props.onStepIndexChange(stepIndex - 1);
    }
  };

  handleHashChange = (hash) => {
    this.setState({hash});
  }

  attemptNext = () => {
    // If there is no `complete`, the nextStepProceed should be called right away, without a loader
    if (!this.currentStepComp.complete) {
      return this.nextStepProceed();
    }

    // Show loader
    this.setState({loading: true});

    // Run step component finish command:
    this.currentStepComp.complete();
  }

  nextStepProceed = () => {
    // Increment stepIndex
    this.handleNext();
    // Hide loader
    this.setState({loading: false});
  }

  nextStepFail = (err) => {
    console.log(err);
    // Hide loader
    this.setState({loading: false});
    // TODO: show error message?
  }

  handleStartOverClicked = () => {
    confirmDialog(`Are you sure you want to start over?`)
      .then(confirmed => {
        if (confirmed) {
          this.props.onStartOverClicked();
        }
      });
  }

  render() {
    const { stepIndex, loading, allowNext, hash } = this.state;
    const { stepperContentProvider:StepperContent, stepDescriptions } = this.props;
    return (
      <div>
        {/* TODO: The errordialog can also be spawnable */}
        <LoaderOverlay visible={this.state.loading}/>
        <StepperBlock stepIndex={stepIndex} stepDescriptions={stepDescriptions}/>
        <div style={styles.contentStyle}>
          <div>
            <StepperContent
              stepIndex={stepIndex}
              sessionHash={hash}
              onValidationChange={valid => this.setState({ allowNext: valid })}
              onRefChange={currentStepComp => this.currentStepComp = currentStepComp}
              onHashChange={this.handleHashChange}
              onNextStepFail={this.nextStepFail}
              proceedAction={this.nextStepProceed}
              goBackAction={this.handlePrev}
            />
            {/* Wizard buttons below */}
            <div style={styles.flexBox}>
              {/* disabled the back button, since we don't need it (yet)
                <FlatButton
                  label='Back'
                  disabled={ loading || stepIndex === 0 }
                  onTouchTap={ this.handlePrev }
                />*/}
              <div className="ContentSpacing" style={styles.buttonArea}>
                <RaisedButton
                  label='Next'
                  primary={true}
                  disabled={ loading || !allowNext || stepIndex >= stepDescriptions.length - 1 }
                  onTouchTap={ this.attemptNext }
                />
                <span style={styles.buttonSpacer}></span>
                <RaisedButton
                  disabled={ loading || stepIndex === 0 }
                  label="Start over"
                  icon={repeatIcon}
                  onTouchTap={this.handleStartOverClicked}
                />
              </div>
              <div style={styles.horizontalFiller}>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const StepPropTypes = {
  stepIndex: PropTypes.number.isRequired, // The index of the current step
  sessionHash: PropTypes.any.isRequired, // Hash that is used to identify the session
  onValidationChange: PropTypes.func.isRequired, // When this step has marked itself as 'ready to complete'
  onRefChange: PropTypes.func.isRequired, // Is called when the reference to the step updates; used by the stepmanager to call `complete` on this step
  onHashChange: PropTypes.func.isRequired, // When the session hash is updated by on of the steps
  onNextStepFail: PropTypes.func.isRequired, // Call this function when an request has failed. it will hide the loader and stop propagation to the next step
  proceedAction: PropTypes.func.isRequired, // Proceed to the next step (without calling this step's `complete` handler)
  goBackAction: PropTypes.func.isRequired, // Move to the previous step
}

export { StepperManager as default, StepPropTypes};

const stepperStyle = { overflowX: 'hidden' };
const StepperBlock = ({stepIndex, stepDescriptions}) => (
  <Paper zDepth={1} className="LowContentSpacing" style={stepperStyle}>
    <Stepper activeStep={stepIndex} >
      {stepDescriptions.map((stepDescription,i) =>
        <Step key={i}>
          <StepLabel>{stepDescription}</StepLabel>
        </Step>
      )}
    </Stepper>
  </Paper>
)

StepperBlock.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  stepDescriptions: PropTypes.array.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/StepperManager/index.js